import React from "react";
import { useLocation, Link } from "react-router-dom";

const RegisterErrorScreen: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const errorMessage =
    location.state?.message ||
    params.get("message") ||
    "Ocorreu um erro inesperado ao criar sua conta.";

  return (
    <section className="stats">
      <div className="container">
        <div className="stat-card cta-content center auth-card">
          <h1 className="auth-title">Algo deu errado</h1>
          <p className="auth-subtitle">{errorMessage}</p>

          <div
            className="auth-actions"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Link to="/cadastro" className="btn-primary">
              Tentar Novamente
            </Link>
            <a href="/central-de-ajuda" className="auth-link">
              Entrar em contato com o suporte
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterErrorScreen;
